
































  import Vue from 'vue';
  import ChampFormulaire from '@/commun/components/champ-formulaire/champ-formulaire.vue';

  export default Vue.extend({
    name: 'DatePicker',
    components: {
      ChampFormulaire,
    },
    props: {
      value: {
        type: String,
        default: '',
      },
      label: {
        type: String,
        default: '',
      },
      validation: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        menuAffichee: false,
        date: this.value,
      };
    },
    methods: {
      onChangerDate(valeur: string): void {
        this.$emit('input', valeur);
        this.menuAffichee = false;
      },
    },
  });
